
define(
	'Code25.CaterpartsGlobal.Register'
	, [
		"Utils", "Tools"
	]
	, function (
		Utils, Tools
	) {
		'use strict';
		//
		return {
			mount: function mount(container) {
				var layout = container.getComponent('Layout');
				if (layout) {
					if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
						var LoginRegister_Register_View = require("LoginRegister.Register.View");

						if (LoginRegister_Register_View) {


							// LoginRegister_Register_View.prototype.bindings['[name="url"]'] = 'url';
							// LoginRegister_Register_View.prototype.bindings['[name="phone"]'] = 'phone';
							// LoginRegister_Register_View.prototype.bindings['[name="custentity_nbshab_business_type"]'] = 'custentity_nbshab_business_type';
							// LoginRegister_Register_View.prototype.bindings['[name="address1"]'] = 'address1';
							// LoginRegister_Register_View.prototype.bindings['[name="address2"]'] = 'address2';
							// LoginRegister_Register_View.prototype.bindings['[name="city"]'] = 'city';
							// LoginRegister_Register_View.prototype.bindings['[name="state"]'] = 'state';
							// LoginRegister_Register_View.prototype.bindings['[name="zip"]'] = 'zip';
							// LoginRegister_Register_View.prototype.bindings['[name="country"]'] = 'country';

							//LoginRegister_Register_View.prototype.bindings['[name="custentity_request_credit_account"]'] = 'custentity_request_credit_account';


							LoginRegister_Register_View.prototype.beforeShowContent= function beforeShowContent() {
								var promise = jQuery.Deferred();
								//var profileModel = ProfileModel.getInstance();
						
								// if (profileModel.get('isLoggedIn') === 'T' && profileModel.get('isGuest') === 'F') {
								// 	Backbone.history.navigate('', { trigger: true });
						
								// 	promise.reject();
								// } else {
									promise.resolve();
								// }
						
								return promise;
							}

						}
					}

						
				}

			}
		};
	});
